<template>
    <div
        v-show="!props.hide"
        @click="onNodeLinkClick"
        :class="`uuid-${config.uuid}`"
    >
        <span class="text">{{ i18n(props.text) || i18nLabel }}</span>
        <i class="mobile-general-form-iconfont icon-nav-forward"></i>
    </div>
</template>
<script>

import ComponentBase from '../component-base';
import { component } from './props';
export default {
    name: component,
    extends: ComponentBase,
    methods: {
        onNodeLinkClick() {
            window.location.href = this.props.link;
        },
    },
};
</script>
